import { render, staticRenderFns } from "./ClassTable.vue?vue&type=template&id=023af60a&scoped=true"
import script from "./ClassTable.vue?vue&type=script&lang=js"
export * from "./ClassTable.vue?vue&type=script&lang=js"
import style0 from "./ClassTable.vue?vue&type=style&index=0&id=023af60a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023af60a",
  null
  
)

export default component.exports